// Translation for mr
export const mr = {
        common: {
            save: 'जतन करा',
            cancel: 'रद्द करा',
            close: 'बंद करा',
            delete: 'हटवा',
            edit: 'संपादित करा',
            activate: 'सक्रिय करा',
            add: 'जोडा',
            saving: 'जतन करत आहे...',
            loading: 'लोड होत आहे...',
            active: 'सक्रिय',
            inUse: 'वापरात आहे',
            test: 'चाचणी',
            searchApps: 'अॅप्स शोधा...',
            betaBanner: 'बीटा - सेवा अद्याप उपलब्ध नाही!'
        },
        header: {
            creditBalance: 'शिल्लक',
            minutes: 'मिनिटे'
        },
        auth: {
            signIn: 'साइन इन करा',
            signUp: 'साइन अप करा',
            username: 'वापरकर्तानाव',
            password: 'पासवर्ड',
            continue: 'सुरू ठेवा',
            noAccount: 'तुमचे खाते नाही का?',
            hasAccount: 'आधीच खाते आहे का?',
            loginError: 'लॉगिन अयशस्वी',
            invalidCredentials: 'अवैध वापरकर्तानाव किंवा पासवर्ड',
            rateLimited: 'खूप जास्त लॉगिन प्रयत्न. कृपया थोडा वेळ थांबा.',
            sessionExpired: 'तुमचे सत्र संपले आहे. कृपया नवीन मॅजिक लिंक वापरा.',
            magicLinkInvalid: 'लॉगिन लिंक अवैध आहे किंवा तिची मुदत संपली आहे.',
            magicLinkSuccess: 'स्वागत आहे! तुम्ही यशस्वीरित्या लॉग इन केले आहे.',
            magicLinkProcessing: 'लॉगिन प्रक्रिया सुरू आहे...',
            connectionError: 'कनेक्शन त्रुटी. कृपया पुन्हा प्रयत्न करा.'
        },
        profile: {
            myProgress: 'माझी शिकण्याची प्रगती',
            signOut: 'साइन आउट',
            plan: 'योजना: '
        },
        settings: {
            title: 'सेटिंग्ज',
            tabs: {
                uiSettings: 'UI सेटिंग्ज',
                systemPrompt: 'सिस्टम प्रॉम्प्ट',
                llmProfiles: 'LLM प्रोफाइल',
                ttsProfiles: 'TTS प्रोफाइल',
                language: 'भाषा',
            },
            uiSettings: {
                title: 'युजर इंटरफेस',
                themeMode: 'थीम मोड',
                darkMode: 'डार्क मोड',
                lightMode: 'लाइट मोड',
                themeColor: 'थीम रंग',
                themeColorDesc: 'बटणे, चिन्हे आणि हायलाइट्ससाठी एक्सेंट रंग निवडा',
                background: 'पार्श्वभूमी',
                backgroundDesc: 'तुमच्या वर्कस्पेससाठी पार्श्वभूमी निवडा',
                selectBackgroundColor: 'पार्श्वभूमी रंग निवडा',
                backgrounds: {
                    cyberSchooling: 'सायबर स्कूलिंग',
                    focus: 'फोकस',
                    concentration: 'एकाग्रता',
                    relaxation: 'विश्रांती',
                    lianas: 'लिआनास',
                    color: 'रंग'
                },
                backgroundColors: {
                    deepDark: 'गडद काळा',
                    darkGrey: 'गडद राखाडी',
                    midnightBlue: 'मिडनाइट ब्लू',
                    indigo: 'इंडिगो',
                    darkTeal: 'गडद टील',
                    brown: 'तपकिरी',
                    darkRed: 'गडद लाल',
                    deepPurple: 'गडद जांभळा',
                    pureWhite: 'शुद्ध पांढरा',
                    softWhite: 'सॉफ्ट व्हाईट',
                    lightGrey: 'फिकट राखाडी',
                    paleBlue: 'फिकट निळा',
                    paleGreen: 'फिकट हिरवा',
                    paleOrange: 'फिकट नारिंगी',
                    lavender: 'लॅव्हेंडर',
                    blueGrey: 'ब्लू ग्रे'
                }
            },
            systemPrompt: {
                label: 'सिस्टम प्रॉम्प्ट:',
                placeholder: 'सिस्टम प्रॉम्प्ट लोड होत आहे...',
                emptyError: 'सिस्टम प्रॉम्प्ट रिकामे असू शकत नाही!',
                saveSuccess: '✓ सिस्टम प्रॉम्प्ट यशस्वीरित्या जतन केले!',
                loadError: 'सिस्टम प्रॉम्प्ट लोड करताना त्रुटी',
                saveError: 'जतन करताना त्रुटी'
            },
            llmProfiles: {
                addButton: '+ नवीन कनेक्शन जोडा',
                newConnection: 'नवीन कनेक्शन',
                editConnection: 'कनेक्शन संपादित करा',
                emptyState: 'कोणतेही LLM कनेक्शन उपलब्ध नाही. जोडण्यासाठी खाली क्लिक करा.',
                loadingProfiles: 'प्रोफाइल लोड होत आहे...',
                nameLabel: 'नाव *',
                namePlaceholder: 'उदा. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API की *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'मॉडेल *',
                modelPlaceholder: 'gpt-4, mistral-tiny इ.',
                allFieldsRequired: 'सर्व फील्ड भरले पाहिजेत!',
                saveSuccess: '✓ प्रोफाइल यशस्वीरित्या जतन केले!',
                deleteConfirm: 'तुम्हाला खरोखर "{name}" हटवायचे आहे का?',
                profileNotFound: 'प्रोफाइल सापडले नाही!',
                loadError: 'प्रोफाइल लोड करताना त्रुटी',
                saveError: 'जतन करताना त्रुटी',
                activateError: 'सक्रिय करताना त्रुटी',
                deleteError: 'हटवताना त्रुटी',
                modelInfo: 'मॉडेल: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ नवीन आवाज जोडा',
                newVoice: 'नवीन आवाज',
                editVoice: 'आवाज संपादित करा',
                emptyState: 'कोणतेही TTS प्रोफाइल उपलब्ध नाही. जोडण्यासाठी खाली क्लिक करा.',
                loadingProfiles: 'TTS प्रोफाइल लोड होत आहे...',
                nameLabel: 'नाव',
                namePlaceholder: 'उदा. माझे ElevenLabs अडम',
                providerLabel: 'प्रदाता',
                providerPlaceholder: 'उदा. ElevenLabs, OpenAI, Piper',
                providerPiper: 'पायपर (स्थानिक)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API की *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'मॉडेल ID *',
                modelIdPlaceholder: 'उदा. eleven_monolingual_v1',
                voiceIdLabel: 'आवाज ID',
                voiceIdPlaceholder: 'उदा. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'सर्व फील्ड भरले पाहिजेत!',
                saveSuccess: '✓ TTS प्रोफाइल यशस्वीरित्या जतन केले!',
                deleteConfirm: 'तुम्हाला खरोखर "{name}" हटवायचे आहे का?',
                loadError: 'TTS प्रोफाइल लोड करताना त्रुटी',
                saveError: 'जतन करताना त्रुटी',
                activateError: 'सक्रिय करताना त्रुटी',
                deleteError: 'हटवताना त्रुटी'
            },
            language: {
                title: 'भाषा निवडा',
                description: 'युजर इंटरफेससाठी तुमची आवडती भाषा निवडा'
            },
        },
        chat: {
            ready: 'तयार',
            start: 'सुरू करा',
            stop: 'थांबा',
            initialMessage: 'रिअल-टाइम संवादासाठी सुरू करा वर क्लिक करा.',
            listening: 'ऐकत आहे...',
            speaking: 'थॉर्स्टन बोलत आहे...',
            userLabel: 'तुम्ही',
            aiLabel: 'AI',
            modalTitle: 'थॉर्स्टन AI चॅट',
            inputPlaceholder: 'संदेश टाइप करा...',
            send: 'पाठवा',
            loginRequired: 'कृपया ही सेवा वापरण्यासाठी साइन इन करा.',
            loginButton: 'आताच साइन इन करा',
            magicLinkRequired: 'साइन इन करण्यासाठी कृपया मॅजिक लिंक वापरा.',
            creditLimitError: 'तुमचा तासाचा कोटा संपला आहे. सुरू ठेवण्यासाठी कृपया तुमची योजना (मीडियम/प्रीमियम) अपग्रेड करा.',
            serviceDisabled: 'चॅट सेवा सध्या उपलब्ध नाही. कृपया नंतर पुन्हा प्रयत्न करा.'
        },
        notifications: {
            error: 'त्रुटि',
            success: 'यशस्वी',
            info: 'माहिती',
            unknownError: 'एक अज्ञात त्रुटी आली'
        },
        cookie: {
            message: 'ही वेबसाइट तुम्हाला सर्वोत्तम वापरकर्ता अनुभव देण्यासाठी कुकीज वापरते.',
            accept: 'स्वीकार करा'
        },
        curriculum: {
                buttonLabel: 'अभ्यासक्रम',
                buttonTitle: 'अभ्यासक्रम सामग्री दाखवा',
                modalTitle: '{app} अभ्यासक्रम',
                sections: {
                    topic: 'अभ्यासक्रम विषय',
                    explanation: 'मुलांसाठी स्पष्टीकरण',
                    studentProfile: 'विद्यार्थी प्रोफाइल'
                },
                topic: {
                    empty: 'या मायक्रो-अॅपशी बॅकएंडमध्ये कोणताही अभ्यासक्रम विषय जोडलेला नाही.',
                    missingDetail: 'या मायक्रो-अॅपसाठी तपशीलवार अभ्यासक्रम डेटा बॅकएंडमध्ये अद्याप उपलब्ध नाही.',
                    learningGoals: 'शिक्षण उद्दिष्टे',
                    prerequisites: 'पूर्वापेक्षा',
                    unitLabel: 'एकक',
                    durationLabel: 'कालावधी',
                    difficultyLabel: 'अडचण पातळी',
                    hours: 'तास',
                    minutes: 'मिनिटे'
                },
                explanation: {
                    empty: 'मुलांसाठी स्पष्टीकरण उपलब्ध नाही.',
                    loadingPrepare: 'AI स्पष्टीकरण तयार करत आहे',
                    loadingExplain: 'AI मुलांसाठी सोप्या भाषेत विषय समजावून सांगत आहे',
                    requestFailed: 'मुलांसाठी स्पष्टीकरण तयार करता आले नाही.'
                },
                studentProfile: {
                    country: 'देश',
                    region: 'राज्य / प्रदेश',
                    schoolType: 'शाळेचा प्रकार',
                    grade: 'इयत्ता',
                    noContext: 'विद्यार्थी संदर्भ उपलब्ध नाही.',
                    childProfileNotFound: 'सध्याच्या लॉगिनसाठी बॅकएंडमध्ये कोणतेही विद्यार्थी प्रोफाइल आढळले नाही.',
                    loginProfileIncomplete: 'लॉगिन प्रोफाइलमध्ये अद्याप पूर्ण विद्यार्थी संदर्भ नाही.',
                    educationContextNotFound: 'विद्यार्थी प्रोफाइल आढळले, परंतु कोणतेही अभ्यासक्रम असाइनमेंट सेट नाही.',
                    noToken: 'साइन इन केलेला विद्यार्थी आढळला नाही.'
                },
                errors: {
                    signInRequired: 'अभ्यासक्रम पाहण्यासाठी कृपया साइन इन करा.',
                    appIdMissing: 'अॅप आयडी गहाळ आहे.',
                    loadFailed: 'अभ्यासक्रम डेटा लोड करता आला नाही.'
                }
            }
    };
